// 安全加固 2026-09-03：自助入驻口已按 B 方案收紧（POST /institutions 需管理员鉴权，见 commit 9129c668），
// 本页转为线下办理指引；原自助表单 / 邀请复制入口随安全收紧一并下线（历史版本见 git 9129c668）。
export default function InstitutionRegister() {
  return (
    <div style={{ paddingTop: 80, padding: 40 }}>
      <div style={{ maxWidth: 600, margin: '0 auto' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 40, textAlign: 'center', boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }}>
          <div style={{ fontSize: 64, marginBottom: 16 }}>🏢</div>
          <h2 style={{ fontSize: 24, marginBottom: 12 }}>机构入驻已转为线下办理</h2>
          <p style={{ color: '#666', lineHeight: 1.9, marginBottom: 24 }}>
            为保障信息安全，线上自助注册通道已关闭。<br />
            如需开通，请联系博小兔工作人员，我们会协助您完成入驻、配置与培训。
          </p>
          <button onClick={() => { window.location.href = '/cms/' }} style={{ padding: '12px 36px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 15 }}>
            返回首页
          </button>
        </div>
      </div>
    </div>
  )
}
